import React, {FC} from "react";
import {
    Button,
    Card,
    CardContent,
    Divider,
    Grid,
    Stack,
    Typography,
} from "@mui/material";
import {IGarageList} from "../../../interfaces/Interfaces";
import {IGarageListColumns} from "./GarageListColumns";
import {Locale} from "../../../locales/Locale";
import {IdlocaGeneric} from "../../../locales/IdlocaGeneric";
import {RenderGaragePhoto} from "../RenderGaragePhoto";

interface Props {
    data: IGarageList[];
    columns: IGarageListColumns[];
    onDetailsClick?: (id: string) => void;
}

export const GarageCardListMobile: FC<Props> = ({data, columns, onDetailsClick}) => {
    return (
        <>
            {data.map((item) => {
                return (
                    <Card key={item.id} sx={{mb: 2}}>
                        <CardContent sx={{textAlign: "left"}}>
                            <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                                <RenderGaragePhoto value={item?.placePhoto} size={80} width={80} height={80}/>
                                <Typography variant="h6" fontWeight="bold">
                                    {item.name}
                                </Typography>
                            </Stack>
                            <Grid container spacing={1}>
                                {columns
                                    .filter(
                                        (col) =>
                                            col.param !== "name" &&
                                            col.param !== "placePhoto" &&
                                            col.param !== "id",
                                    )
                                    .map((col) => {
                                        const value = item[col.param];
                                        const rendered = col.renderer ? (
                                            <col.renderer value={value}/>
                                        ) : (
                                            value
                                        );

                                        return (
                                            <Grid
                                                item
                                                xs={12}
                                                key={col.param}
                                                sx={{
                                                    display: "flex",
                                                    gap: 1,
                                                    alignItems: "flex-start",
                                                    textAlign: "left",
                                                }}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    color="textSecondary"
                                                    sx={{minWidth: 70}}
                                                >
                                                    <Locale localeId={col.locaId as IdlocaGeneric}/>:
                                                </Typography>
                                                <Typography variant="body2" flex={1}>
                                                    {rendered}
                                                </Typography>
                                            </Grid>
                                        );
                                    })}
                            </Grid>
                            <Divider sx={{my: 2}}/>
                            {onDetailsClick && (
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    onClick={() => onDetailsClick(String(item.id))}
                                >
                                    <Locale localeId={IdlocaGeneric.view_details}/>
                                </Button>
                            )}
                        </CardContent>
                    </Card>
                );
            })}
        </>
    );
};
